<template>
  <div class="app sidebar-mini rtl">
    <nav-bar></nav-bar>
    <main class="app-content">
      <slot></slot>
    </main>
    <footer class="footer">
      <div>
        <div class="text-muted">
          <span
            >{{ moment().format('YYYY') }} &copy; {{ $t('Stem Cell Data Base') }}</span
          >
          <span
            >{{ $t('Версия') }} 3.0.3 (UZB)</span
          >
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import Nav from './Nav.vue';
import Uploader from '../components/Uploader.vue';
import Input from '../components/Input.vue';
import PhoneInput from '../components/PhoneInput.vue';
import FileInput from '../components/FileInput.vue';
import SimpleInput from '../components/SimpleInput.vue';
import Select from '../components/Select.vue';
import Title from '../components/Title.vue';
import TextArea from '../components/TextArea.vue';
import CheckBox from '../components/CheckBox.vue';
import TweetBox from '../components/TweetBox.vue';
import StaticText from '../components/StaticText.vue';
import LinkText from '../components/LinkText.vue';
import CustomDatePicker from '../components/CustomDatePicker.vue';
import HlaInput from '../components/HlaInput.vue';
import DownloadInput from '../components/DownloadInput.vue';
import FileGeneratorButton from '../components/FileGeneratorButton.vue';
import Hlas from '../components/Hlas.vue';
import HistoryGrid from '../components/grid/HistoryGrid.vue';
import Accessible from '../components/Accessible.vue';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import VueClipboard from 'vue-clipboard2';
import moment from 'moment'; 

import FilterAgeSelect from '../components/filter/FilterAgeSelect.vue';
import FilterInput from '../components/filter/FilterInput.vue';
import FilterCheckbox from '../components/filter/FilterCheckbox.vue';
import FilterSelect from '../components/filter/FilterSelect.vue';
import FilterDateRange from '../components/filter/FilterDateRange.vue';
import FilterDateBetween from '../components/filter/FilterDateBetween.vue';
import FilterDatePicker from '../components/filter/FilterDatePicker.vue';
import FilterStaticText from '../components/filter/FilterStaticText.vue';
import Inputmask from 'inputmask';

import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import VueSwal from 'vue-swal';
import VeeValidate, { Validator } from 'vee-validate';
import ValidationHelper from '../helpers/validation.js';
import GridCodeInput from "@/components/GridCodeInput";

import VueValidationRu from '@/locale/vee-validate/ru';
import VueValidationEn from '@/locale/vee-validate/en';
import VueValidationKk from '@/locale/vee-validate/kk';
import VueValidationKa from '@/locale/vee-validate/ka';
import VueValidationAz from '@/locale/vee-validate/az';
const VueUploadComponent = require('vue-upload-component');

Vue.component('file-upload', VueUploadComponent);
Vue.component('uploader', Uploader);
Vue.component('nav-bar', Nav);
Vue.component('rdkm-input', Input);
Vue.component('rdkm-phone', PhoneInput);
Vue.component('rdkm-download-input', DownloadInput);
Vue.component('rdkm-file-generator-button', FileGeneratorButton);
Vue.component('simple-input', SimpleInput);
Vue.component('rdkm-select', Select);
Vue.component('rdkm-title', Title);
Vue.component('rdkm-text-area', TextArea);
Vue.component('rdkm-checkbox', CheckBox);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('rdkm-static-text', StaticText);
Vue.component('rdkm-link-text', LinkText);
Vue.component('rdkm-tweet', TweetBox);
Vue.component('rdkm-date-picker', CustomDatePicker);
Vue.component('user-accessible', Accessible);
Vue.component('multiselect', Multiselect);
Vue.component('filter-input', FilterInput);
Vue.component('filter-age-select', FilterAgeSelect);
Vue.component('filter-checkbox', FilterCheckbox);
Vue.component('filter-date-between', FilterDateBetween);
Vue.component('filter-select', FilterSelect);
Vue.component('filter-date-range', FilterDateRange);
Vue.component('filter-date-picker', FilterDatePicker);
Vue.component('filter-static-text', FilterStaticText);
import dpLanguages from '@/locale/datepicker';
const mydp = Vue.component('dp', DatePicker).extend({
 computed: {
      language () {
      return dpLanguages[this.lang];
    },
  },
});
Vue.component('date-picker', mydp);
Vue.component('grid-code-input', GridCodeInput);
Vue.component('hla-input', HlaInput);
Vue.component('hlas', Hlas);
Vue.component('history-grid', HistoryGrid);
Vue.component('rdkm-file-input', FileInput);

Vue.directive('mask', {
  bind: function(el, binding) {
    Inputmask(binding.value).mask(el);
  },
});
Validator.localize({ en: VueValidationEn, 
                     ru: VueValidationRu,
                     az: VueValidationAz,
                     kk: VueValidationKk,
                     ka: VueValidationKa })

Vue.use(VeeValidate, {
  locale: (localStorage.lang || 'Ru').toLowerCase(),
  fieldsBagName: 'veeFields',

});

ValidationHelper.addCustomValidation(VeeValidate.Validator);

library.add(fas);
dom.watch();

Vue.use(VueSwal);
Vue.use(VueClipboard);

export default {
  name: 'layout',
  data() {
    return {
      currentTime: '',
      version: process.env.PACKAGE_VERSION || '0',
      publishDate: process.env.PUBLISH_DATE || '0'
    };
  },

  created() {
   this.$auth.fetchUser();
    setInterval(
      () => (this.currentTime = moment().format('DD.MM.YYYY HH:mm')),
      1000 * 30
    );
  },

  mounted() {
    this.currentTime = moment().format('DD.MM.YYYY HH:mm');
    axios
      .get('/Settings/PageSize')
      .then((res) => {
        window.pageSize = res.data;
      })
      .catch((e) => {
        window.pageSize = 10;
      });
    axios
        .get('/Settings/GetByCode?code=ISSUING_ORG_NUM')
        .then((res) => {
          window.ion = res.data;
        })
        .catch((e) => {
          window.ion = null;
        });
  },
};
</script>

<style>
.app-content {
  padding: 0px;
}

.tile {
  padding: 5px;
}

.dropdown .dropdown-menu .dropdown-item:focus {
  outline: none;
}

nav a.router-link-active {
  font-weight: 700;
}

.app-header__logo {
  color: grey;
  background-color: #e7e7e7;
  text-align: left;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.footer {
  font-size: 15px;
  font-family: sans-serif;
  bottom: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: space-between;
}

footer .text-muted {
  padding-left: 240px;
  color: #777;
}

footer .text-muted span {
  padding-right: 20px;
}

footer .arsis-logo {
  font-size: 14px;
  font-style: italic;
  display: inline-block;
  padding-right: 10px;
}

footer .arsis-logo span {
  padding-right: 10px;
}

footer .arsis-logo a {
  padding-right: 8px;
}

.card-footer .btn {
  margin-left: 10px;
}

.card-footer .btn {
  width: 130px;
}

.card label {
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}

.card header {
  text-transform: uppercase;
}

.app-menu svg {
  margin-right: 10px;
}
</style>
